import { render } from "./i-date.vue?vue&type=template&id=5fd0d2aa"
import script from "./i-date.vue?vue&type=script&lang=js"
export * from "./i-date.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__